<div class="payment-result-page" testId="payment-result-page">
  <nz-card class="result-card" testId="payment-result-card">
    <nz-spin [nzSpinning]="loading" testId="payment-result-spin">
      <div class="status-head" testId="payment-result-status-head">
        <div class="status-icon" [class]="getStatusIconClass()" testId="payment-result-status-icon">
          <i
            nz-icon
            [nzType]="getStatusIcon()"
            [nzTheme]="displayStatus === 'processing' ? 'outline' : 'fill'"
            [class.status-icon-spinning]="displayStatus === 'processing'"
          ></i>
        </div>
        <div class="status-copy" testId="payment-result-status-copy">
          <h2 testId="payment-result-title">{{ getTitleKey() | i18n }}</h2>
          <p testId="payment-result-description">{{ getDescriptionKey() | i18n }}</p>
        </div>
      </div>

      <div class="status-panel" *ngIf="countdownText" testId="payment-result-countdown-panel">
        <div class="panel-label" testId="payment-result-countdown-label">{{ 'payment.result.countdown.label' | i18n }}</div>
        <div class="panel-value" testId="payment-result-countdown-value">{{ countdownText }}</div>
      </div>

      <div class="meta-grid" testId="payment-result-meta-grid">
        <div class="meta-item" testId="payment-result-meta-scope">
          <div class="meta-label">{{ 'payment.result.scope.label' | i18n }}</div>
          <div class="meta-value">{{ getScopeLabel() }}</div>
        </div>
        <div class="meta-item" testId="payment-result-meta-order-id">
          <div class="meta-label">{{ 'payment.result.order-id.label' | i18n }}</div>
          <div class="meta-value">{{ getOrderIdText() }}</div>
        </div>
        <div class="meta-item" testId="payment-result-meta-expire-time">
          <div class="meta-label">{{ 'payment.result.expire-time.label' | i18n }}</div>
          <div class="meta-value">{{ getExpireTimeText() }}</div>
        </div>
        <div class="meta-item" testId="payment-result-meta-sync">
          <div class="meta-label">{{ 'payment.result.sync.label' | i18n }}</div>
          <div class="meta-value">{{ getSyncStatusKey() | i18n }}</div>
        </div>
      </div>

      <div class="action-row" *ngIf="canRetryRefresh()" testId="payment-result-action-row">
        <button nz-button nzType="default" [nzLoading]="refreshing" (click)="retryRefresh()" testId="payment-result-refresh-button">
          {{ 'payment.result.action.refresh' | i18n }}
        </button>
      </div>
    </nz-spin>
  </nz-card>
</div>
